import { VERSION_6HD_INT_GALLERY } from "../../../../../common-deprecated/constants";
import {
    type ImageOptionsType,
    getVisualForGradeImage,
} from "../../../../../common-deprecated/settings/utils/ccisSettingUtils";
import { useBnbSelector } from "../../redux/store";
import { getCarImageFromConfig } from "../../../../shared-logic/utils/typedUtils";

export enum ImageType {
    Exterior,
    InteriorGallery,
    Interior3D,
    Top,
}

type getCarImageProps = {
    width: number;
    height: number;
    modelId: string;
    gradeId: string;
    bodyTypeId: string;
    defaultCarId: string;
    colorCode?: string;
};

type getFrameProps = {
    width: number;
    height: number;
    modelId: string;
    gradeId: string;
    bodyTypeId: string;
    configVersion: string;
    frame: number;
    options?: ImageOptionsType;
};

type useCarImageReturnType = {
    getImage: (props: getCarImageProps) => string;
    getFrame: (props: getFrameProps) => string;
};

export const useCarImage = (): useCarImageReturnType => {
    const settings = useBnbSelector((state) => state.commonSettings);
    const filterItems = useBnbSelector((state) => state.model.filterItems);
    const filterEquipment = useBnbSelector((state) => state.utils.filterEquipment);
    const isSelected = filterEquipment.split(":")[0] === "true";

    const getImage = ({
        width,
        height,
        modelId,
        gradeId,
        bodyTypeId,
        defaultCarId,
        colorCode,
    }: getCarImageProps): string => {
        return filterItems.length
            ? getCarImageFromConfig(
                  settings,
                  "day-exterior",
                  0,
                  modelId,
                  defaultCarId,
                  { type: "jpg", width, height },
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  false,
                  null,
                  false,
                  isSelected ? filterItems : [],
              )
            : getVisualForGradeImage(
                  settings,
                  modelId,
                  gradeId,
                  bodyTypeId,
                  {
                      width,
                      height,
                      padding: 0,
                      scaleMode: 0,
                  },
                  9,
                  colorCode,
              ).src;
    };

    const getFrame = ({
        width,
        height,
        modelId,
        gradeId,
        bodyTypeId,
        frame,
        configVersion,
        options,
    }: getFrameProps): string => {
        return getVisualForGradeImage(
            settings,
            modelId,
            gradeId,
            bodyTypeId,
            {
                width,
                height,
                imageQuality: 75,
                padding: 0,
                scaleMode: 1,
                ...options,
            },
            frame,
            undefined,
            undefined,
            configVersion !== VERSION_6HD_INT_GALLERY ? "day-interior" : "static-day-interior",
        ).src;
    };

    return {
        getImage,
        getFrame,
    };
};
